import { Municipality } from "app/addresses/store/municipalities/municipalities.model";
import { AdministrativeRegion, DecisionDocument, InsuranceStatusCode, PublicMember, PublicMemberInfos, PublicMemberSearchCriterias, SpecialtyType } from "./public-member-search.model";

export class LoadSpecialities {
  constructor() { }
  static readonly type = '[PublicMemberSearch] LoadSpecialities';
}
export class LoadSpecialitiesSuccess {
  constructor(public specialities: SpecialtyType[]) { }
  static readonly type = '[PublicMemberSearch] LoadSpecialitiesSuccess';
}
export class LoadSpecialitiesFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] LoadSpecialitiesFailure';
}


export class SearchMunicipality {
  constructor(public serchTerm: string) { }
  static readonly type = '[PublicMemberSearch] SearchMunicipality';
}
export class SearchMunicipalitySuccess {
  constructor(public municipalities: Municipality[]) { }
  static readonly type = '[PublicMemberSearch] SearchMunicipalitySuccess';
}
export class SearchMunicipalityFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] SearchMunicipalityFailure';
}


export class SearchPublicMemberBy {
  constructor(public cityName: string,
    public specialtyTypeId: string,
    public administrativeRegionCode: string,
    public isAnesthesiaHospital: boolean,
    public isAnesthesiaPrivateClinic: boolean,
    public isParticularMedicalCondition: boolean,
    public isHomeVisit: boolean,
    public isSleepApnea: boolean,
    public isReducedMobility: boolean,
    public isLiftPerson: boolean) { }
  static readonly type = '[PublicMemberSearch] SearchPublicMemberBy';
}
export class SearchPublicMemberBySuccess {
  constructor(public members: PublicMember[], public criterias: PublicMemberSearchCriterias) { }
  static readonly type = '[PublicMemberSearch] SearchPublicMemberBySuccess';
}
export class SearchPublicMemberByFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] SearchPublicMemberByFailure';
}


export class FetchMemberPublicInfos {
  constructor(public memberId: string) { }
  static readonly type = '[PublicMemberSearch] FetchMemberPublicInfos';
}
export class FetchMemberPublicInfosSuccess {
  constructor(public memberPublicInfos: PublicMemberInfos) { }
  static readonly type = '[PublicMemberSearch] FetchMemberPublicInfosSuccess';
}
export class FetchMemberPublicInfosFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] FetchMemberPublicInfosFailure';
}

export class LoadAdministrativeRegions {
  constructor() { }
  static readonly type = '[PublicMemberSearch] LoadAdministrativeRegions';
}
export class LoadAdministrativeRegionsSuccess {
  constructor(public administrativeRegions: AdministrativeRegion[]) { }
  static readonly type = '[PublicMemberSearch] LoadAdministrativeRegionsSuccess';
}
export class LoadAdministrativeRegionsFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] LoadAdministrativeRegionsFailure';
}


export class DownloadDecisionDocument {
  constructor(public document: DecisionDocument) { }
  static readonly type = '[PublicMemberSearch] DownloadDecisionDocument';
}
export class DownloadDecisionDocumentSuccess {
  constructor() { }
  static readonly type = '[PublicMemberSearch] DownloadDecisionDocumentSuccess';
}
export class DownloadDecisionDocumentFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] DownloadDecisionDocumentFailure';
}

export class LoadInsuranceStatusCodes {
  constructor() { }
  static readonly type = '[PublicMemberSearch] LoadInsuranceStatusCodes';
}
export class LoadInsuranceStatusCodesSuccess {
  constructor(public insuranceStatusCodes: InsuranceStatusCode[]) { }
  static readonly type = '[PublicMemberSearch] LoadInsuranceStatusCodesSuccess';
}
export class LoadInsuranceStatusCodesFailure {
  constructor(public error: any) { }
  static readonly type = '[PublicMemberSearch] LoadInsuranceStatusCodesFailure';
}